export default __webpack_public_path__ + "i18n/translations/translation-pt.7a80f2c2.json";